// Twilio Configuration
// Get your credentials from: https://console.twilio.com
// Setup guide: See TWILIO_SETUP_GUIDE.md
//
// IMPORTANT: This config works differently for Web vs Mobile:
// 
// For Web:
//   - Uses environment variables from .env file (injected by webpack DefinePlugin)
//   - Set REACT_APP_TWILIO_* in .env file
//
// For Mobile (React Native):
//   - Uses hardcoded values from twilio-config.js (since React Native doesn't load .env)
//   - Update twilio-config.js with your credentials

import { Platform } from 'react-native';

// Import hardcoded config for mobile (React Native doesn't load .env files)
// Use same-directory path so Metro reliably bundles it (../../twilio-config.js can fail in RN)
let mobileTwilioConfig: any = null;
if (Platform.OS !== 'web') {
  try {
    // Load root-level file (keeps secrets out of src and avoids web bundler path warnings).
    mobileTwilioConfig = require('../../twilio-config.js');
  } catch {
    console.warn('⚠️ Could not load twilio-config.js for mobile, using empty values');
  }
}

export const TWILIO_CONFIG = {
  // For web: Use environment variables (injected by webpack DefinePlugin)
  // For mobile: Use hardcoded values from twilio-config.js
  accountSid: Platform.OS === 'web' 
    ? (process.env.TWILIO_ACCOUNT_SID || process.env.REACT_APP_TWILIO_ACCOUNT_SID || '')
    : (mobileTwilioConfig?.accountSid || ''),
  authToken: Platform.OS === 'web'
    ? (process.env.TWILIO_AUTH_TOKEN || process.env.REACT_APP_TWILIO_AUTH_TOKEN || '')
    : (mobileTwilioConfig?.authToken || ''),
  phoneNumber: Platform.OS === 'web'
    ? (process.env.TWILIO_PHONE_NUMBER || process.env.REACT_APP_TWILIO_PHONE_NUMBER || '+18778843550')
    : (mobileTwilioConfig?.phoneNumber || '+18778843550'),
  
  // Webhook URLs for Twilio
  voiceWebhook: process.env.TWILIO_VOICE_WEBHOOK || process.env.REACT_APP_TWILIO_VOICE_WEBHOOK || 'https://bookapt-sms-webhook.onrender.com/api/twilio/voice-handler',
  messagingWebhook: process.env.TWILIO_MESSAGING_WEBHOOK || process.env.REACT_APP_TWILIO_MESSAGING_WEBHOOK || 'https://bookapt-sms-webhook.onrender.com/api/twilio/sms-webhook',
  
  // Optional: Webhook for delivery status
  statusCallback: process.env.TWILIO_STATUS_CALLBACK || process.env.REACT_APP_TWILIO_STATUS_CALLBACK || '',
  
  // Settings
  maxRetries: parseInt(process.env.TWILIO_MAX_RETRIES || '3', 10),
  retryDelay: parseInt(process.env.TWILIO_RETRY_DELAY || '5000', 10), // milliseconds
};

// Validate configuration
export const validateTwilioConfig = (): boolean => {
  const { accountSid, authToken, phoneNumber } = TWILIO_CONFIG;
  
  if (!accountSid || accountSid === 'ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx') {
    console.error('❌ Twilio Account SID not configured!');
    console.log('👉 Get it from: https://console.twilio.com');
    return false;
  }
  
  if (!authToken || authToken === 'your_auth_token_here') {
    console.error('❌ Twilio Auth Token not configured!');
    console.log('👉 Get it from: https://console.twilio.com (click Show)');
    return false;
  }
  
  if (!phoneNumber || phoneNumber === '+15551234567') {
    console.error('❌ Twilio Phone Number not configured!');
    console.log('👉 Buy one at: https://console.twilio.com/phone-numbers');
    console.log('👉 Current number should be: +18778843550');
    return false;
  }
  
  console.log('✅ Twilio configuration valid!');
  return true;
};

// Helper: Check if we're in test mode
export const isTwilioTestMode = (): boolean => {
  return !validateTwilioConfig();
};

export default TWILIO_CONFIG;




